import Icon from '@vfz/ui/dist/components/icon/icon';
import { VZButton } from 'components/Button/button.styles';
import { Modal } from 'components/Modal';
import { ModalButtons, ModalIcon } from 'components/Modal/modal.styles';
import { content } from 'pages/Products/pages/InternetProducts/pages/EmailSettings/components/SectionEmail/section-email.content';
import React from 'react';
import { ContentUtil } from 'utils/content';

const contentUtil = new ContentUtil({ content, componentName: 'SectionEmail' });

interface IRemovalFailedModalProps {
  closeModal(): void;
}

export const RemovalFailedModal = ({ closeModal }: IRemovalFailedModalProps) => (
  <Modal onClose={closeModal}>
    {(onClose) => (
      <section data-testid="modal-removal-failed">
        <ModalIcon>
          <Icon name="settingsError" />
        </ModalIcon>
        <h4>{contentUtil.translate('removalFailedModal.header')}</h4>
        {contentUtil.translateHtml('removalFailedModal.content')}
        <ModalButtons>
          <VZButton onClick={onClose} variant="outlined">
            {contentUtil.translate('removalFailedModal.button')}
          </VZButton>
        </ModalButtons>
      </section>
    )}
  </Modal>
);
